(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('expandable-text')) {
    class ExpandableText extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.expandable-text__content');
        this.button = this.querySelector('.expandable-text__toggle');
        if (!this.content || !this.button) return;

        this.onClick = this.toggle.bind(this);
        this.button.addEventListener('click', this.onClick);

        this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
        this.resizeObserver.observe(this);
        this.checkOverflow();
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onClick);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      checkOverflow() {
        if (this.classList.contains('is-expanded')) return;
        const overflowing = this.content.scrollHeight > this.content.clientHeight + 1;
        this.classList.toggle('is-overflowing', overflowing);
        this.button.hidden = !overflowing;
      }

      toggle() {
        const content = this.content;
        const expand = !this.classList.contains('is-expanded');

        if (expand) {
          content.style.maxHeight = content.scrollHeight + 'px';
          this.classList.add('is-expanded');

          const noTransition = parseFloat(getComputedStyle(content).transitionDuration) === 0;
          if (noTransition) {
            content.style.maxHeight = 'none';
          } else {
            content.addEventListener('transitionend', () => {
              if (this.classList.contains('is-expanded')) content.style.maxHeight = 'none';
            }, { once: true });
          }
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.offsetHeight; // force reflow so the collapse animates
          this.classList.remove('is-expanded');
          content.style.maxHeight = '';
        }

        this.button.setAttribute('aria-expanded', expand);
        this.button.textContent = expand
          ? this.button.dataset.labelLess
          : this.button.dataset.labelMore;
      }
    }

    customElements.define('expandable-text', ExpandableText);
  }

  } catch(e) { console.error(e); }
})();
})();
